import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {FileDownloadService} from '../../../shared/components/file_download/file_download.service';

import Swal from 'sweetalert2';
import 'rxjs/add/observable/of';
import {ActivatedRoute} from '@angular/router';
import {FilesService} from '../files/files.service';
import {File} from '../files/model/file';

@Component({
  selector: 'app-files',
  templateUrl: './files-count-download.component.html'
})
export class FilesCountDownloadComponent implements OnInit {

    private campType: string;

    files: Array<File>;
    enabled: boolean;
    filePk: string = '';

    @ViewChild(DatatableComponent) table: DatatableComponent;

    constructor(private filesSrv: FilesService, private fileDownload: FileDownloadService, private activatedRoute: ActivatedRoute) {
        this.files = [];
        this.enabled = false;

        this.fileDownload.getSubject().asObservable().subscribe(
            (msg) => {
                Swal('File download error', msg, 'error');
            }
        );

    }


    /**
     * inits component
     */
    ngOnInit() {
        this.activatedRoute.params.subscribe(
            (params: Object) => {
                this.enabled = true;
                this.filePk = params['id'];
                const query = { 'pk' : this.filePk };
                this.filesSrv.findCountFiles(query).subscribe(
                    data => {
                        this.files = data;
                        this.enabled = false;
                    }
                );
            }
        );
    }
};



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/files-count-download/files-count-download.component.ts